export default __webpack_public_path__ + "static/graphik-web-black-59bc4f985b40b3b15f2a879e824f719f.woff2";